import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Auth travels via the HttpOnly `de_token` cookie (withCredentials). Attach the active
// value format — but never override a format a page has explicitly requested (e.g. the
// DME Player Values board, which has its own 1QB/SF/TEP toggle independent of the global one).
api.interceptors.request.use((cfg) => {
  const explicit = cfg.params && cfg.params.format;
  const fmt = localStorage.getItem("de_format") || "auto";
  cfg.params = { ...(cfg.params || {}), format: explicit || fmt };
  return cfg;
});

export function getFormat() {
  return localStorage.getItem("de_format") || "auto";
}

export function formatValue(v) {
  if (v === null || v === undefined) return "—";
  return v.toLocaleString("en-US");
}

// Position-aware: kickers, team defenses and IDP players aren't valued by dynasty asset
// markets, so show their position label instead of a misleading "0" or "—".
const _IDP_POS = new Set(["LB", "DL", "DE", "DT", "DB", "CB", "S", "EDGE", "IDP", "SS", "FS", "NT", "OLB", "ILB"]);
export function formatAssetValue(v, position) {
  if (v && v > 0) return v.toLocaleString("en-US");
  const pos = String(position || "").toUpperCase();
  if (_IDP_POS.has(pos)) return "IDP";
  if (pos === "K") return "K";
  if (pos === "DEF" || pos === "DST") return "DEF";
  return "—";
}

export function pctColor(p) {
  if (p > 0) return "text-emerald-400";
  if (p < 0) return "text-red-400";
  return "text-zinc-400";
}
